(function () {

  function initializeFilmOrigin(root) {

    if (!root || root.dataset.foInitialized === 'true') {
      return;
    }

    root.dataset.foInitialized = 'true';

    const input = root.querySelector('[data-fo-query]');
    const button = root.querySelector('[data-fo-search]');
    const results = root.querySelector('[data-fo-results]');
    const status = root.querySelector('[data-fo-status]');
    const apiUrl = root.dataset.foApiUrl;

    if (!input || !button || !results || !status) {
      return;
    }

    if (!apiUrl) {
      status.textContent =
        'FILM ORIGIN database connection could not be found.';
      button.disabled = true;
      return;
    }


    /* ==============================
       HELPERS
    ============================== */

    function escapeHTML(value) {

      return String(value ?? '').replace(
        /[&<>"']/g,
        function (character) {

          return {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
          }[character];

        }
      );

    }


    function safeURL(value) {

      if (!value) {
        return '';
      }

      try {

        const url = new URL(
          value,
          window.location.origin
        );

        if (
          url.protocol === 'http:' ||
          url.protocol === 'https:'
        ) {
          return url.href;
        }

      } catch (error) {
        return '';
      }

      return '';

    }


    function formatList(items) {

      if (!Array.isArray(items)) {
        return '';
      }

      return items.join(', ');

    }


    /* ==============================
       SOURCES
    ============================== */

    function renderSources(item) {

      const sources =
        Array.isArray(item.sources)
          ? item.sources
          : [];

      if (!sources.length) {
        return '';
      }

      const sourceHTML = sources
        .map(function (source) {

          const sourceURL =
            safeURL(source.url);

          if (!sourceURL) {
            return '';
          }

          return `
            <div style="margin-top:8px;">
              <a
                href="${escapeHTML(sourceURL)}"
                target="_blank"
                rel="noopener noreferrer"
              >
                ${escapeHTML(
                  source.label ||
                  'Evidence source'
                )} ↗
              </a>
            </div>
          `;

        })
        .join('');

      if (!sourceHTML) {
        return '';
      }

      return `
        <div class="fo-sources">
          <b>Evidence Sources</b>
          ${sourceHTML}
        </div>
      `;

    }


    /* ==============================
       MYANMAR DEALERS
    ============================== */

    function renderMyanmarDealers(item) {

      const dealers =
        Array.isArray(
          item.myanmarAuthorizedDealers
        )
          ? item.myanmarAuthorizedDealers
          : [];

      if (!dealers.length) {

        return `
          <div class="fo-sources">

            <b>
              Myanmar Dealer / Distributor
            </b>

            <p class="fo-note">
              No Myanmar authorized dealer or
              distributor is currently recorded.
            </p>

          </div>
        `;

      }

      const dealerHTML =
        dealers.map(
          function (dealer) {

            const sourceURL =
              safeURL(
                dealer.source_url
              );

            return `

              <div
                style="
                  margin-top:16px;
                  padding:16px;
                  border:1px solid rgba(0,0,0,.10);
                  border-radius:10px;
                "
              >

                <small>
                  MYANMAR DEALER / DISTRIBUTOR
                </small>

                <h3
                  style="margin:5px 0 12px;"
                >
                  ${escapeHTML(
                    dealer.dealer_name ||
                    'Dealer / Distributor'
                  )}
                </h3>

                <div class="fo-grid">

                  <div>
                    <label>City</label>
                    <strong>
                      ${escapeHTML(
                        dealer.city ||
                        'Myanmar'
                      )}
                    </strong>
                  </div>

                  <div>
                    <label>Role</label>
                    <strong>
                      ${escapeHTML(
                        dealer.role ||
                        'Dealer / Distributor'
                      )}
                    </strong>
                  </div>

                  <div class="fo-wide">
                    <label>
                      Authorization Status
                    </label>
                    <strong>
                      ${escapeHTML(
                        dealer.authorization_status ||
                        'Not independently confirmed'
                      )}
                    </strong>
                  </div>

                  ${
                    dealer.address
                      ? `
                        <div class="fo-wide">
                          <label>
                            Address
                          </label>
                          <strong>
                            ${escapeHTML(
                              dealer.address
                            )}
                          </strong>
                        </div>
                      `
                      : ''
                  }

                </div>

                ${
                  dealer.note
                    ? `
                      <p class="fo-note">
                        ${escapeHTML(
                          dealer.note
                        )}
                      </p>
                    `
                    : ''
                }

                ${
                  sourceURL
                    ? `
                      <div class="fo-sources">
                        <a
                          href="${escapeHTML(
                            sourceURL
                          )}"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          ${escapeHTML(
                            dealer.source_name ||
                            'Dealer verification source'
                          )} ↗
                        </a>
                      </div>
                    `
                    : ''
                }

              </div>

            `;

          }
        )
        .join('');

      return `

        <div class="fo-sources">

          <b>
            Myanmar Dealer / Distributor
          </b>

          ${dealerHTML}

        </div>

      `;

    }


    /* ==============================
       MYANMAR SOCIAL EVIDENCE
    ============================== */

    function renderMyanmarSocial(item) {

      const mentions =
        Array.isArray(
          item.myanmarSocialMentions
        )
          ? item.myanmarSocialMentions
          : [];

      if (!mentions.length) {
        return '';
      }

      const mentionHTML =
        mentions.map(
          function (mention) {

            const sourceURL =
              safeURL(
                mention.source_url
              );

            const products =
              formatList(
                mention.products_or_models
              );

            return `

              <div
                style="
                  margin-top:14px;
                  padding-top:14px;
                  border-top:1px solid rgba(0,0,0,.08);
                "
              >

                <strong>
                  ${escapeHTML(
                    mention.page_name ||
                    'Myanmar market source'
                  )}
                </strong>

                ${
                  mention.city
                    ? `
                      <div class="fo-note">
                        Location:
                        ${escapeHTML(
                          mention.city
                        )}
                      </div>
                    `
                    : ''
                }

                ${
                  mention.platform
                    ? `
                      <div class="fo-note">
                        Platform:
                        ${escapeHTML(
                          mention.platform
                        )}
                      </div>
                    `
                    : ''
                }

                ${
                  products
                    ? `
                      <div class="fo-note">
                        Product / Model:
                        ${escapeHTML(
                          products
                        )}
                      </div>
                    `
                    : ''
                }

                ${
                  mention.post_date
                    ? `
                      <div class="fo-note">
                        Observed / Post date:
                        ${escapeHTML(
                          mention.post_date
                        )}
                      </div>
                    `
                    : ''
                }

                ${
                  mention.evidence_strength
                    ? `
                      <div class="fo-note">
                        Evidence level:
                        ${escapeHTML(
                          mention.evidence_strength
                        )}
                      </div>
                    `
                    : ''
                }

                ${
                  mention.note
                    ? `
                      <p class="fo-note">
                        ${escapeHTML(
                          mention.note
                        )}
                      </p>
                    `
                    : ''
                }

                ${
                  sourceURL
                    ? `
                      <a
                        href="${escapeHTML(
                          sourceURL
                        )}"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        View Myanmar source ↗
                      </a>
                    `
                    : ''
                }

              </div>

            `;

          }
        )
        .join('');

      return `

        <div class="fo-sources">

          <b>
            Myanmar Market / Social Media Evidence
          </b>

          ${mentionHTML}

        </div>

      `;

    }


    /* ==============================
       RESULT CARD
    ============================== */

    function renderRecord(item) {

      const officialURL =
        safeURL(
          item.officialWebsite
        );

      const dealerHTML =
        renderMyanmarDealers(item);

      const socialHTML =
        renderMyanmarSocial(item);

      const sourcesHTML =
        renderSources(item);

      return `

        <article class="fo-card">

          <div class="fo-head">

            <div>

              <small>
                ${escapeHTML(
                  item.product ||
                  'Automotive Film / PPF'
                )}
              </small>

              <h2>
                ${escapeHTML(
                  item.brand ||
                  'Unknown Brand'
                )}
              </h2>

            </div>

            ${
              item.confidence
                ? `
                  <span class="fo-badge">
                    ${escapeHTML(
                      item.confidence
                    )}
                  </span>
                `
                : ''
            }

          </div>


          <div class="fo-grid">

            <div>
              <label>
                Brand Origin
              </label>
              <strong>
                ${escapeHTML(
                  item.brandOrigin ||
                  'Unknown'
                )}
              </strong>
            </div>


            <div>
              <label>
                Product
              </label>
              <strong>
                ${escapeHTML(
                  item.product ||
                  'Not specified'
                )}
              </strong>
            </div>


            <div>
              <label>
                Company
              </label>
              <strong>
                ${escapeHTML(
                  item.company ||
                  'Unknown'
                )}
              </strong>
            </div>


            <div>
              <label>
                Manufacturer
              </label>
              <strong>
                ${escapeHTML(
                  item.manufacturer ||
                  'Unknown'
                )}
              </strong>
            </div>


            <div>
              <label>
                Manufacturing Country
              </label>
              <strong>
                ${escapeHTML(
                  item.manufacturingCountry ||
                  'Unknown'
                )}
              </strong>
            </div>


            <div>
              <label>
                Factory / Production Base
              </label>
              <strong>
                ${escapeHTML(
                  item.factory ||
                  'Unknown'
                )}
              </strong>
            </div>


            ${
              item.myanmarPresence
                ? `
                  <div class="fo-wide">
                    <label>
                      Myanmar Presence
                    </label>
                    <strong>
                      ${escapeHTML(
                        item.myanmarPresence
                      )}
                    </strong>
                  </div>
                `
                : ''
            }


            ${
              item.lastVerified
                ? `
                  <div class="fo-wide">
                    <label>
                      Last Verified
                    </label>
                    <strong>
                      ${escapeHTML(
                        item.lastVerified
                      )}
                    </strong>
                  </div>
                `
                : ''
            }

          </div>


          ${
            item.note
              ? `
                <p class="fo-note">
                  ${escapeHTML(
                    item.note
                  )}
                </p>
              `
              : ''
          }


          ${
            item.myanmarPresenceNotes
              ? `
                <p class="fo-note">

                  <strong>
                    Myanmar market note:
                  </strong>

                  ${escapeHTML(
                    item.myanmarPresenceNotes
                  )}

                </p>
              `
              : ''
          }


          ${
            officialURL
              ? `
                <div class="fo-sources">

                  <b>
                    Brand Website
                  </b>

                  <a
                    href="${escapeHTML(
                      officialURL
                    )}"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Official website ↗
                  </a>

                </div>
              `
              : ''
          }


          ${sourcesHTML}

          ${dealerHTML}

          ${socialHTML}

        </article>

      `;

    }


    /* ==============================
       NOT FOUND
    ============================== */

    function renderNotFound(query) {

      return `

        <article class="fo-card">

          <div class="fo-head">

            <div>

              <small>
                FILM ORIGIN
              </small>

              <h2>
                Research required
              </h2>

            </div>

            <span class="fo-badge">
              NOT YET RESEARCHED
            </span>

          </div>


          <p>

            FILM ORIGIN does not currently
            have a reviewed record for

            <strong>
              ${escapeHTML(query)}
            </strong>.

          </p>


          <p class="fo-note">

            A missing record does not mean
            that the brand or product is suspicious.

            It means sufficient reliable information
            has not yet been added to the database.

          </p>

        </article>

      `;

    }


    /* ==============================
       SEARCH API
    ============================== */

    async function searchFilmOrigin() {

      const originalQuery =
        input.value.trim();

      if (!originalQuery) {

        status.textContent =
          'Please enter a brand or product name.';

        results.innerHTML = '';

        return;

      }


      button.disabled = true;

      const originalButtonText =
        button.textContent;

      button.textContent =
        'Checking...';

      status.textContent =
        'Searching FILM ORIGIN research database...';

      results.innerHTML = '';


      try {

        const requestURL =
          apiUrl +
          '?search=' +
          encodeURIComponent(
            originalQuery
          );


        const response =
          await fetch(
            requestURL,
            {
              method: 'GET',
              cache: 'no-store'
            }
          );


        if (!response.ok) {

          throw new Error(
            'API request failed: ' +
            response.status
          );

        }


        const database =
          await response.json();


        if (!database.success) {

          throw new Error(
            database.error ||
            'FILM ORIGIN API returned an error.'
          );

        }


        const matches =
          Array.isArray(database.results)
            ? database.results
            : [];


        if (!matches.length) {

          status.textContent =
            'No reviewed record found for "' +
            originalQuery +
            '".';

          results.innerHTML =
            renderNotFound(
              originalQuery
            );

          return;

        }


        status.textContent =
          matches.length +
          (
            matches.length === 1
              ? ' research record found.'
              : ' research records found.'
          );


        results.innerHTML =
          matches
            .map(renderRecord)
            .join('');


      } catch (error) {

        console.error(
          'FILM ORIGIN API error:',
          error
        );


        status.textContent =
          'FILM ORIGIN database could not be reached. Please try again.';


        results.innerHTML = `

          <article class="fo-card">

            <div class="fo-head">

              <div>

                <small>
                  FILM ORIGIN
                </small>

                <h2>
                  Connection problem
                </h2>

              </div>

            </div>

            <p class="fo-note">
              The research database is temporarily unavailable.
              Please try your search again.
            </p>

          </article>

        `;

      } finally {

        button.disabled = false;

        button.textContent =
          originalButtonText;

      }

    }


    /* ==============================
       EVENTS
    ============================== */

    button.addEventListener(
      'click',
      searchFilmOrigin
    );


    input.addEventListener(
      'keydown',
      function (event) {

        if (event.key === 'Enter') {

          event.preventDefault();

          searchFilmOrigin();

        }

      }
    );


    status.textContent =
      'FILM ORIGIN database ready.';

  }


  /* ==============================
     INITIALIZE
  ============================== */

  function initializeAllFilmOriginSections() {

    document
      .querySelectorAll(
        '[data-film-origin]'
      )
      .forEach(
        initializeFilmOrigin
      );

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeAllFilmOriginSections
    );

  } else {

    initializeAllFilmOriginSections();

  }


  /*
    Shopify Theme Editor
  */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      let section = null;

      if (
        event.target.matches &&
        event.target.matches(
          '[data-film-origin]'
        )
      ) {

        section =
          event.target;

      } else {

        section =
          event.target.querySelector(
            '[data-film-origin]'
          );

      }


      if (section) {

        section.dataset.foInitialized =
          'false';

        initializeFilmOrigin(
          section
        );

      }

    }
  );


})();